import { render, staticRenderFns } from "./ProductAQ.vue?vue&type=template&id=f41b6ffc&scoped=true&"
import script from "./ProductAQ.vue?vue&type=script&lang=js&"
export * from "./ProductAQ.vue?vue&type=script&lang=js&"
import style0 from "./ProductAQ.vue?vue&type=style&index=0&id=f41b6ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41b6ffc",
  null
  
)

export default component.exports